import DisplayAdSlot from './DisplayAdSlot';

export default function DialogDisplayAd(props) {
  return <DisplayAdSlot {...props} deregisterDisplaySlot={false} isInDialog />;
}
